import Navigator from 'app';
import ErrorView from './views/error_view';
export default {
  showError: function () {
    Navigator.errorView = new ErrorView();
    Navigator.mainRegion.show(Navigator.errorView);
  }
};